'use es6';

import http from 'hub-http/clients/apiClient';
import * as actionTypes from './actionTypes';
import TagsApi from '../../api/TagsApi';
import AuthorsApi from '../../api/AuthorsApi';
import BlogsApi from 'ContentEditorUI/api/BlogsApi';
import BlogListingPagesApi from '../../api/BlogListingPagesApi';
import { fetchNotificationEmails as fetchNotificationEmailsApiHelper } from 'ContentEditorUI/api/EmailsApi';
import FileManagerApi from 'ContentEditorUI/api/FileManagerApi';
import SocialAccountsApi from 'ContentEditorUI/api/SocialAccountsApi';
import SocialAutoPublishingApi from 'ContentEditorUI/api/SocialAutoPublishingApi';
import { showErrorWithHTML } from 'ContentEditorUI/utils/errorUtils';
import { FETCH_SETTINGS_SLUG_FAIL, FETCH_SETTINGS_SLUG_REQUEST } from 'ContentEditorUI/redux/actions/actionTypes';
import { SLUG_FOR_TITLE_URL } from 'ContentEditorUI/lib/pageSettings/constants';
import { updatePostContentModelSlug } from './postContentModelActions';
import { getContentModelBlogAuthorAsJSObject, getContentModelTagListAsJSObject, getContentModelTagIdsAsJSObject } from '../selectors/postContentModelSelectors';

// UPDATES ------------------------------->

export const updateShowAllErrors = showErrors => {
  return {
    type: actionTypes.UPDATE_POST_SETTINGS_SHOW_ALL_ERRORS,
    payload: showErrors
  };
};
export const updateCustomizeTitleEnabled = enabled => {
  return {
    type: actionTypes.UPDATE_POST_SETTINGS_CUSTOMIZE_TITLE_ENABLED,
    payload: enabled
  };
};
export const updateSyncTitleSlugFlag = shouldSync => {
  return {
    type: actionTypes.UPDATE_POST_SETTINGS_SYNC_TITLE_SLUG,
    payload: shouldSync
  };
};
export const updateCreateAuthorModalOpen = open => {
  return {
    type: actionTypes.UPDATE_POST_CREATE_AUTHOR_MODAL_OPEN,
    payload: open
  };
};
export const updateSocialAutoPublishingField = message => {
  return {
    type: actionTypes.UPDATE_POST_SETTINGS_SOCIAL_AUTO_PUBLISHING_FIELD,
    payload: message
  };
};

// REQUEST FAILURES ---------------------->

const fetchPostTagsFailed = error => {
  return {
    type: actionTypes.FETCH_POST_TAGS_FAILED,
    payload: error
  };
};
const createPostTagFailed = error => dispatch => {
  showErrorWithHTML({
    response: error,
    action: 'tagEditor'
  });
  dispatch({
    type: actionTypes.CREATE_POST_TAG_FAILED,
    payload: error
  });
};
const createPostTagTranslationFailed = error => dispatch => {
  showErrorWithHTML({
    response: error,
    action: 'tagEditor'
  });
  dispatch({
    type: actionTypes.CREATE_POST_TAG_TRANSLATION_FAILED,
    payload: error
  });
};
const fetchPostAvailableAuthorsFailed = error => {
  return {
    type: actionTypes.FETCH_POST_AVAILABLE_AUTHORS_FAILED,
    payload: error
  };
};
const fetchPostBlogsFailed = error => {
  return {
    type: actionTypes.FETCH_POST_BLOGS_FAILED,
    payload: error
  };
};
const createPostAuthorFailed = error => dispatch => {
  showErrorWithHTML({
    response: error,
    action: 'authorEditor'
  });
  dispatch({
    type: actionTypes.CREATE_POST_AUTHOR_FAILED,
    payload: error
  });
};
const fetchNotificationEmailsFailed = error => {
  return {
    type: actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_FAILED,
    payload: error
  };
};
const fetchSocialAutoPublishStatusFailed = error => {
  return {
    type: actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_FAILED,
    payload: error
  };
};
const fetchSocialBroadcastsFailed = error => {
  return {
    type: actionTypes.FETCH_SOCIAL_BROADCASTS_FAILED,
    payload: error
  };
};
const fetchSocialAutoPublishingFailed = error => {
  return {
    type: actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_FAILED,
    payload: error
  };
};
const saveSocialAutoPublishingFailed = error => {
  return {
    type: actionTypes.UPDATE_POST_SOCIAL_AUTO_PUBLISHING_FAILED,
    payload: error
  };
};
const fetchSocialAccountsFailed = error => {
  return {
    type: actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_FAILED,
    payload: error
  };
};
const fetchFeaturedImageThumbnailUrlsFailed = error => {
  return {
    type: actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_FAILED,
    payload: error
  };
};

// REQUEST SUCCESSES --------------------->

const fetchPostTagsSucceeded = ({
  objects,
  total
}, selectedTagList, selectedTagIds) => {
  return {
    type: actionTypes.FETCH_POST_TAGS_SUCCEEDED,
    payload: {
      objects,
      total,
      selectedTagList,
      selectedTagIds
    }
  };
};
const createPostTagSucceeded = tagInfo => {
  return {
    type: actionTypes.CREATE_POST_TAG_SUCCEEDED,
    payload: tagInfo
  };
};
const createPostTagTranslationSucceeded = tagInfo => {
  return {
    type: actionTypes.CREATE_POST_TAG_TRANSLATION_SUCCEEDED,
    payload: tagInfo
  };
};
const fetchPostAvailableAuthorsSucceeded = ({
  objects
}, selectedAuthor) => {
  return {
    type: actionTypes.FETCH_POST_AVAILABLE_AUTHORS_SUCCEEDED,
    payload: {
      objects,
      selectedAuthor
    }
  };
};
const fetchPostBlogsSucceeded = blogInfo => {
  return {
    type: actionTypes.FETCH_POST_BLOGS_SUCCEEDED,
    payload: blogInfo
  };
};
const createPostAuthorSucceeded = blogAuthor => {
  return {
    type: actionTypes.CREATE_POST_AUTHOR_SUCCEEDED,
    payload: {
      blogAuthor
    }
  };
};
const fetchNotificationEmailsSucceeded = blogInfo => {
  return {
    type: actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_SUCCEEDED,
    payload: blogInfo
  };
};
const fetchSocialAutoPublishStatusSucceeded = statusInfo => {
  return {
    type: actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_SUCCEEDED,
    payload: statusInfo
  };
};
const fetchSocialBroadcastsSucceeded = broadcasts => {
  return {
    type: actionTypes.FETCH_SOCIAL_BROADCASTS_SUCCEEDED,
    payload: broadcasts
  };
};
const fetchSocialAutoPublishingSucceeded = bapInfo => {
  return {
    type: actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED,
    payload: bapInfo
  };
};
const saveSocialAutoPublishingSucceeded = bapInfo => {
  return {
    type: actionTypes.UPDATE_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED,
    payload: bapInfo
  };
};
const fetchSocialAccountsSucceeded = bapInfo => {
  return {
    type: actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_SUCCEEDED,
    payload: bapInfo
  };
};
const fetchFeaturedImageThumbnailUrlsSucceeded = imageUrls => {
  return {
    type: actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_SUCCEEDED,
    payload: imageUrls
  };
};

// REQUESTS ------------------------------>

export const fetchPostTags = (language, search, page) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.FETCH_POST_TAGS_STARTED
  });
  const success = resp => dispatch(fetchPostTagsSucceeded(resp, getContentModelTagListAsJSObject(getState()), getContentModelTagIdsAsJSObject(getState())));
  const error = resp => dispatch(fetchPostTagsFailed(resp));
  TagsApi.fetch(language, search, page).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const createPostTag = (tag, language) => dispatch => {
  dispatch({
    type: actionTypes.CREATE_POST_TAG_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(createPostTagSucceeded(resp));
      dispatch(fetchPostTags(language));
    } else {
      dispatch(createPostTagFailed());
    }
  };
  const error = resp => dispatch(createPostTagFailed(resp));
  TagsApi.create(tag, language).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const createPostTagTranslation = (masterId, masterLanguage, language, tagName) => dispatch => {
  dispatch({
    type: actionTypes.CREATE_POST_TAG_TRANSLATION_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(createPostTagTranslationSucceeded(resp));
      dispatch(fetchPostTags(language));
    } else {
      dispatch(createPostTagTranslationFailed());
    }
  };
  const error = resp => dispatch(createPostTagTranslationFailed(resp));
  TagsApi.createTranslation(masterId, masterLanguage, language, tagName).then(success, error).catch(() => {
    throw new Error('Could not create translation');
  });
};
export const fetchPostAvailableAuthors = blogLanguage => (dispatch, getState) => {
  dispatch({
    type: actionTypes.FETCH_POST_AVAILABLE_AUTHORS_STARTED
  });
  const author = getContentModelBlogAuthorAsJSObject(getState());
  const success = resp => {
    if (resp) {
      dispatch(fetchPostAvailableAuthorsSucceeded(resp, author));
    } else {
      dispatch(fetchPostAvailableAuthorsFailed());
    }
  };
  const error = resp => dispatch(fetchPostAvailableAuthorsFailed(resp));
  AuthorsApi.fetch(blogLanguage).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchPostBlogs = () => dispatch => {
  dispatch({
    type: actionTypes.FETCH_POST_BLOGS_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchPostBlogsSucceeded(resp));
    } else {
      dispatch(fetchPostBlogsFailed());
    }
  };
  const error = resp => dispatch(fetchPostBlogsFailed(resp));
  BlogsApi.fetch().then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const createAuthor = (authorInfo, translatedFromId, masterLanguage) => dispatch => {
  dispatch({
    type: actionTypes.CREATE_POST_AUTHOR_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchPostAvailableAuthors(authorInfo.language));
      dispatch(createPostAuthorSucceeded(resp));
    } else {
      dispatch(createPostAuthorFailed());
    }
  };
  const error = resp => dispatch(createPostAuthorFailed(resp));
  if (translatedFromId) {
    AuthorsApi.createTranslation(authorInfo, translatedFromId, masterLanguage).then(success, error).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  } else {
    AuthorsApi.create(authorInfo).then(success, error).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
};
export const fetchNotificationEmails = ids => dispatch => {
  dispatch({
    type: actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchNotificationEmailsSucceeded(resp));
    } else {
      dispatch(fetchNotificationEmailsFailed());
    }
  };
  const error = resp => dispatch(fetchNotificationEmailsFailed(resp));
  fetchNotificationEmailsApiHelper(ids).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchSocialAutoPublishStatus = blogId => dispatch => {
  dispatch({
    type: actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchSocialAutoPublishStatusSucceeded(resp));
    } else {
      dispatch(fetchSocialAutoPublishStatusFailed());
    }
  };
  const error = resp => dispatch(fetchSocialAutoPublishStatusFailed(resp));
  SocialAutoPublishingApi.fetchStatus(blogId).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchSocialBroadcasts = postId => dispatch => {
  dispatch({
    type: actionTypes.FETCH_SOCIAL_BROADCASTS_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchSocialBroadcastsSucceeded(resp));
    } else {
      dispatch(fetchSocialBroadcastsFailed());
    }
  };
  const error = resp => dispatch(fetchSocialBroadcastsFailed(resp));
  SocialAutoPublishingApi.fetchBroadcasts(postId).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchSocialAutoPublishing = postId => dispatch => {
  dispatch({
    type: actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchSocialAutoPublishingSucceeded(resp));
    } else {
      dispatch(fetchSocialAutoPublishingFailed());
    }
  };
  const error = resp => dispatch(fetchSocialAutoPublishingFailed(resp));
  SocialAutoPublishingApi.fetch(postId).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const saveSocialAutoPublishing = (postId, message) => dispatch => {
  dispatch({
    type: actionTypes.UPDATE_POST_SOCIAL_AUTO_PUBLISHING_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(saveSocialAutoPublishingSucceeded(resp));
    } else {
      dispatch(saveSocialAutoPublishingFailed());
    }
  };
  const error = resp => dispatch(saveSocialAutoPublishingFailed(resp));
  SocialAutoPublishingApi.save(postId, message).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchSocialAccounts = userId => dispatch => {
  dispatch({
    type: actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchSocialAccountsSucceeded(resp));
    } else {
      dispatch(fetchSocialAccountsFailed());
    }
  };
  const error = resp => dispatch(fetchSocialAccountsFailed(resp));
  SocialAccountsApi.fetch(userId).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchFeaturedImageThumbnailUrls = imageUrls => dispatch => {
  dispatch({
    type: actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchFeaturedImageThumbnailUrlsSucceeded(resp));
    } else {
      dispatch(fetchFeaturedImageThumbnailUrlsFailed(resp));
    }
  };
  const error = resp => dispatch(fetchFeaturedImageThumbnailUrlsFailed(resp));
  FileManagerApi.fetchImageThumbnailUrls(imageUrls).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
const fetchSlugForTitleFailure = error => {
  return {
    type: FETCH_SETTINGS_SLUG_FAIL,
    payload: error
  };
};
export const fetchSlugForTitle = (htmlTitle, {
  blogId,
  contentId
}) => dispatch => {
  dispatch({
    type: FETCH_SETTINGS_SLUG_REQUEST
  });
  const success = resp => {
    if (resp && resp.slug) {
      dispatch(updatePostContentModelSlug(resp.slug, blogId));
    } else {
      fetchSlugForTitleFailure(resp);
    }
  };
  const error = err => dispatch(fetchSlugForTitleFailure(err));
  http.get(SLUG_FOR_TITLE_URL, {
    query: {
      title: htmlTitle,
      contentId
    }
  }).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchBlogListingPages = () => dispatch => {
  dispatch({
    type: actionTypes.FETCH_BLOG_LISTING_PAGES_STARTED
  });
  const error = resp => {
    dispatch({
      type: actionTypes.FETCH_BLOG_LISTING_PAGES_FAILED,
      payload: resp
    });
  };
  const success = resp => {
    if (resp) {
      dispatch({
        type: actionTypes.FETCH_BLOG_LISTING_PAGES_SUCCEEDED,
        payload: resp
      });
    } else {
      error(resp);
    }
  };
  BlogListingPagesApi.fetch().then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};